import { render, staticRenderFns } from "./ServiceOptions.vue?vue&type=template&id=fbf24400&scoped=true"
import script from "./ServiceOptions.vue?vue&type=script&lang=js"
export * from "./ServiceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf24400",
  null
  
)

export default component.exports